import { useEffect, useState } from 'react';

/**
 * An index that steps through `0..count-1` every `intervalMs`, for the workspace's cycling
 * examples. Stays on 0 for users who asked for reduced motion.
 */
export function useCycleIndex(count: number, intervalMs: number): number {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const interval = setInterval(() => setIndex((i) => (i + 1) % count), intervalMs);
    return () => clearInterval(interval);
  }, [count, intervalMs]);

  return index;
}
